import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGiteaComponent } from './simple-icons-gitea.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGiteaComponent ],
    exports:      [ SimpleIconsGiteaComponent ],
    bootstrap:    []
})
export class SimpleIconsGiteaModule {}
